var categories = [
    'agricultural',
    'cars',
    'commercial',
    'construction',
    'marine',
    'motorcycles',
    'trucks',
];
var categoriesEnum;
(function (categoriesEnum) {
    categoriesEnum[categoriesEnum["cars"] = 1] = "cars";
    categoriesEnum[categoriesEnum["commercial"] = 2] = "commercial";
    categoriesEnum[categoriesEnum["trucks"] = 3] = "trucks";
    categoriesEnum[categoriesEnum["motorcycles"] = 4] = "motorcycles";
    categoriesEnum[categoriesEnum["agricultural"] = 5] = "agricultural";
    categoriesEnum[categoriesEnum["marine"] = 6] = "marine";
    categoriesEnum[categoriesEnum["off-highway"] = 7] = "off-highway";
    categoriesEnum[categoriesEnum["construction"] = 10] = "construction";
})(categoriesEnum || (categoriesEnum = {}));
var categoriesOatsEnum;
(function (categoriesOatsEnum) {
    categoriesOatsEnum[categoriesOatsEnum["cars"] = 1] = "cars";
    categoriesOatsEnum[categoriesOatsEnum["vans"] = 2] = "vans";
    categoriesOatsEnum[categoriesOatsEnum["motorcycles"] = 3] = "motorcycles";
    categoriesOatsEnum[categoriesOatsEnum["trucks"] = 4] = "trucks";
    categoriesOatsEnum[categoriesOatsEnum["agricultural"] = 5] = "agricultural";
    categoriesOatsEnum[categoriesOatsEnum["off_highway"] = 6] = "off_highway";
    categoriesOatsEnum[categoriesOatsEnum["construction"] = 7] = "construction";
})(categoriesOatsEnum || (categoriesOatsEnum = {}));
var categoriesInfomediaEnum;
(function (categoriesInfomediaEnum) {
    categoriesInfomediaEnum[categoriesInfomediaEnum["cars"] = 1] = "cars";
    categoriesInfomediaEnum[categoriesInfomediaEnum["commercial"] = 2] = "commercial";
    categoriesInfomediaEnum[categoriesInfomediaEnum["trucks"] = 3] = "trucks";
    categoriesInfomediaEnum[categoriesInfomediaEnum["motorcycles"] = 4] = "motorcycles";
    categoriesInfomediaEnum[categoriesInfomediaEnum["engine"] = 8] = "engine";
    categoriesInfomediaEnum[categoriesInfomediaEnum["trimmer"] = 9] = "trimmer";
    categoriesInfomediaEnum[categoriesInfomediaEnum["agricultural"] = 12] = "agricultural";
    categoriesInfomediaEnum[categoriesInfomediaEnum["off-highway"] = 13] = "off-highway";
    categoriesInfomediaEnum[categoriesInfomediaEnum["construction"] = 14] = "construction";
})(categoriesInfomediaEnum || (categoriesInfomediaEnum = {}));
var matchCatrgories = function (value) {
    for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
        var category = categories_1[_i];
        var reg = new RegExp(category, 'i');
        if (reg.test(value)) {
            return category;
        }
    }
    return undefined;
};
var getTypeFromId = function (id, type) {
    if (type === void 0) { type = 'olyslager'; }
    console.log('olys');
    if (type.startsWith('olyslager')) {
        return categoriesEnum[id];
    }
    else if (type.startsWith('infomedia')) {
        if ((id === 5) || (id === 6) || (id === 7)) {
            return 'marine';
        }
        else if (id === 10 || id === 11) {
            return 'mower';
        }
        return categoriesInfomediaEnum[id];
    }
    else if (type.startsWith('oats')) {
        return categoriesOatsEnum[id];
    }
    else {
        return categoriesEnum[id];
    }
};
export default matchCatrgories;
export { getTypeFromId };
